module.exports = __webpack_public_path__ + "img/am-banner-btn.9caac8d2.png";